import { useEffect } from 'react';

const usePrintOnMount = () => {
  useEffect(() => {
    // Due to Firefox for Android does not supported window.print.
    if (typeof window.print === 'function') {
      window.print();
    }
  }, []);
};

export default usePrintOnMount;
